// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__13Ce5","checkboxCol":"Table_checkboxCol__Z7wUv","emailCol":"Table_emailCol__31qNX","actionCol":"Table_actionCol__V2JNt"};